// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const letterSpacings = {
  wide: '-0.02em',
  regular: '-0.03em',
}

export default letterSpacings
